import React from 'react';
import { Select } from 'antd';

const SelectServiceInvoiceMunicipalBenefitType = ({ ...rest }) => {
  return (
    <Select {...rest} allowClear>
      <Select.Option value="exemption">Isenção</Select.Option>
      <Select.Option value="reductionOfTaxBasePercentage">
        Redução da base de cálculo em percentual
      </Select.Option>
      <Select.Option value="reductionOfTaxBaseAmount">
        Redução da base de cálculo em valor monetário
      </Select.Option>
      <Select.Option value="differentiatedRate">
        Alíquota diferenciada
      </Select.Option>
    </Select>
  );
};

export default SelectServiceInvoiceMunicipalBenefitType;
